export class Breadcrumb {
  label: string = null;
  path: string = null;


  constructor(label: string, path: string) {
    this.label = label;
    this.path = path;
  }
}
